import React from 'react'
import {withGoogleReCaptcha} from 'react-google-recaptcha-v3'
import {Row, Col, Spin, Result, Typography} from 'antd'
import ReactComponent from '../app/ReactComponent'
import RegistrationForm from './registration-form/RegistrationForm'
import {STATUS, DASHBOARD_TEXTS, FORM_TEXTS} from './helpers/misc.js'
import App from '../app/App.js'
import {validateForm, getPersonalInformationObject} from './dashboard/dashboardUtils'

const {Title} = Typography

class CustomerPortal extends ReactComponent {
  state = {
    form_submitted_successfully: false,
    scrollToField: null,
    verification_status: STATUS.NEW,
    // Form state
    form_data: {
      gender: '',
      first_name: '',
      last_name: '',
      street: '',
      city: '',
      zip: '',
      country: '',
      email: '',
      phone: '',
      birth_date: '',
      terms_accepted: false
    },
    loading: false,
    error: null,
    form_errors: {}

  }

  async componentDidMount() {

  }

  capitalizeWords(str) {
    return str
      .split(' ')
      .map(word => {
        if(word.length === 0) return ''
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      })
      .join(' ')
  }

  handleFormChange = (field, value) => {

    if(field === 'first_name' || field === 'last_name' || field === 'city')
      value = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()

    if(field === 'email')
      value = value.toLowerCase()

    if(field === 'street') {
      value = this.capitalizeWords(value)
    }

    if(field === 'zip')
      value = value.replace(/\s+/g, '')

    void this.updateState({
      form_data: {
        ...this.state.form_data,
        [field]: value
      },
      form_errors: {
        ...this.state.form_errors,
        [field]: null
      }
    })
  }

  handleSubmitForm = async (data) => {

    const {form_data, card_code, customer_data_raw, verification_status} = this.state
    const {googleReCaptchaProps} = this.props

    const errors = validateForm(form_data)
    if(Object.keys(errors).length > 0) {
      const firstErrorField = Object.keys(errors)[0]
      await this.updateState({
        form_errors: errors,
        scrollToField: firstErrorField
      })
      return
    }

    void this.updateState({loading: true})

    console.log('FORM SEND', form_data, data)
    //return

    try {
      const recaptcha_token = await googleReCaptchaProps.executeRecaptcha('benu_submit_form')
      const registrationData = getPersonalInformationObject(form_data)
      const response = await this.$app.registerCustomer(card_code, registrationData, recaptcha_token)

      if(response.status === 'created') {

        void this.updateState({
          form_submitted_successfully: true,
          verification_status: STATUS.CREATED
        })

      } else {
        App.$e(response.message || DASHBOARD_TEXTS.formGenericError)
      }
    } catch (error) {
      const invalidParams = error.response?.data?.error?.error_data?.invalid_params
      const emailExists = Array.isArray(invalidParams) && invalidParams.some(
        param => param.name === 'email' && param.reason === 'already_exists'
      )

      if(emailExists) {
        void this.updateState({
          form_errors: {
            ...this.state.form_errors,
            email: DASHBOARD_TEXTS.formEmailConflictError // Using formEmailConflictError as it's more appropriate
          },
          scrollToField: 'email'
        })
      } else {
        App.$e(DASHBOARD_TEXTS.formGenericError)
      }
    } finally {
      void this.updateState({loading: false})
    }
  }

  render() {

    return (
      <div className="card-verification">
        <Spin spinning={this.state.loading} size="large">
          <Row justify="center">
            <Col xs={22} sm={18} md={12} lg={8}>
              {this.state.form_submitted_successfully ?

                <div className="verification-box">
                  <Result
                    status="success"
                    title={DASHBOARD_TEXTS.formRegisterSuccessTitle}
                  />
                </div>

                :

                <div className="verification-box">

                  <div style={{marginBottom: '24px', textAlign: 'center'}}>
                    <Title level={3} style={{color: '#142654', marginTop: 0}}>
                      {FORM_TEXTS.newCardTitle}
                    </Title>
                    <p>Pre správnu registráciu vyplňte všetky údaje vrátane diakritiky.</p>
                    <p>Ak už máte plastovú alebo virtuálnu Vernostnú kartu BENU, svoje údaje si môžete jednoducho aktualizovať na stránke <a href="https://vernost.benulekaren.sk" target="_blank">vernost.benulekaren.sk</a>.</p>
                  </div>
                  <RegistrationForm
                    formData={this.state.form_data}
                    formErrors={this.state.form_errors}
                    verificationStatus={STATUS.NEW}
                    onFormChange={this.handleFormChange}
                    onSubmit={this.handleSubmitForm}
                    loading={this.state.loading}
                    scrollToField={this.state.scrollToField}
                    onScrollComplete={() => this.updateState({scrollToField: null})}
                  />
                </div>

              }
            </Col>
          </Row>
        </Spin>
      </div>
    )
  }
}

export default withGoogleReCaptcha(CustomerPortal)